import { Types } from "src/api/@types";
import { generateGetEndpoint, generatePostEndpoint } from "src/api/@utils";
import { useDSWJobsEndpoints } from "./jobs";
// import { baseURL as rootURL } from "..";

// THIS IS A BAD WAY TO DO THIS BUT IS THE CURRENT WORKAROUND DUE TO CIRCULAR DEPENDENCY ISSUES
const baseURL = "/pd" + "/dsw"

const useDSWEndpoints = () => {
    const jobs = useDSWJobsEndpoints()
    const view = generatePostEndpoint<{from?: number, to?: number}, {data: Array<any>, mostRecentJob: any}>(baseURL + "/view");  
    const viewTotals = generatePostEndpoint<{from?: number, to?: number}, {data: Array<any>, mostRecentJob: any}>(baseURL + "/view-totals");  

    return {
        jobs,
        view,
        viewTotals
    }
}

export {
    baseURL,
    useDSWEndpoints,
};